module.exports = __webpack_public_path__ + "img/dzmitry.b__600x600.74092514.jpg";